// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { TendoCloudConfiguratorServiceClientJSON } from '@/twirp/api.twirp-client'

import { axiosRPC } from '@/services/rpc'

export * from '@/twirp/api'

export const TCCService = new TendoCloudConfiguratorServiceClientJSON(axiosRPC)
